<template lang="pug">
div 
    a-card(:bordered="false")
        span(v-for="line, index in previewContent" :key="index" v-if="index < 5")
            a-card-grid(:style="`width:${100/line.length}%`" v-for="item, i in line" :key="item" v-if="i < 5")
                MarketRtChart(:code="item")
   
</template>

<script>
import _ from 'lodash';
import MarketRtChart from '../components/MarketRtChart.vue';
import registerEchartsComponents from './registerEcharts.js';

export default {
    props: ['name', 'id'],
    data() {
        return {
            visible: false,
            previewContent: []
        }
    },
    mounted() {
        registerEchartsComponents();
        this.load();
    },
    methods: {
        load() {
            this.visible = true;
            this.$api.request('GET', `download/${this.id}`, {}, 'fs')
            .then(res => {
                console.log(res.data);
                this.previewContent =_.chain(res.data.split('\n'))
                     .map(_.trim)
                     .map(line => line.split(','))
                     .filter(line => line.length > 0)
                     .value();
            });
        }
    },
    components: {
        MarketRtChart
    }
}
</script>

<style lang="less" scoped>

.rt-dashboard {
    // background-color: rgb(221, 221, 221);
    height: 100%;
}
</style>